import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function editDraftDocument(projectName, formName, documentId, data) {
    try {
        const response = await axios.patch(`/project/${projectName}/${formName}/document/${documentId}/edit`, data);
        return response.data;
    } catch (error) {
        store.dispatch(showToastAction({
            message: error.response?.data?.errorMessage ?? "Error updating draft document",
            showToast: true
        }));
        throw error;
    }
}
